// Auto-generated by scripts/generate_daily_seo_content.js
// Do not edit this file manually.

const dailySeoContent = {
  "updatedAt": "2026-10-17",
  "topic": "德州扑克下载 / 德扑平台下载 / 德州扑克规则",
  "metaKeywords": "德州扑克下载, 德扑平台下载, 德州扑克规则, hhpoker客服, hhpoker俱乐部id怎么找, 德扑下载入口, 德扑下载最新版, hhpoker官网入口, hhpoker官网地址, hhpoker下载",
  "focusKeywords": [
    {
      "keyword": "德州扑克下载",
      "path": "/download",
      "anchorText": "德州扑克下载入口"
    },
    {
      "keyword": "德扑平台下载",
      "path": "/download",
      "anchorText": "德扑平台下载指南"
    },
    {
      "keyword": "德州扑克规则",
      "path": "/guide",
      "anchorText": "德州扑克规则"
    },
    {
      "keyword": "hhpoker客服",
      "path": "/contact",
      "anchorText": "hhpoker客服通道"
    },
    {
      "keyword": "hhpoker俱乐部id怎么找",
      "path": "/clubs",
      "anchorText": "hhpoker俱乐部id怎么找说明"
    },
    {
      "keyword": "德扑下载入口",
      "path": "/download",
      "anchorText": "德扑下载入口"
    },
    {
      "keyword": "德扑下载最新版",
      "path": "/download",
      "anchorText": "德扑下载最新版入口"
    },
    {
      "keyword": "hhpoker官网入口",
      "path": "/",
      "anchorText": "hhpoker官网入口教程"
    },
    {
      "keyword": "hhpoker官网地址",
      "path": "/",
      "anchorText": "hhpoker官网地址"
    },
    {
      "keyword": "hhpoker下载",
      "path": "/download",
      "anchorText": "hhpoker下载入口"
    }
  ],
  "faqEntries": [
    {
      "name": "德州扑克下载怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "从官方渠道下载最新安装包，安卓允许未知来源后直接覆盖安装；iOS需在设置中信任企业证书，全程保持Wi-Fi连接。"
      },
      "linkPath": "/download"
    },
    {
      "name": "德扑平台下载怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "从官方渠道下载最新安装包，安卓允许未知来源后直接覆盖安装；iOS需在设置中信任企业证书，全程保持Wi-Fi连接。"
      },
      "linkPath": "/download"
    },
    {
      "name": "德州扑克规则怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "德州扑克核心流程：盲注→翻牌前→翻牌圈→转牌圈→河牌圈，每轮可选择弃牌/过牌/跟注/加注，最终比牌型大小决定胜负。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "hhpoker客服怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "通过本站客服渠道提交问题，并附上截图和复现步骤，可明显缩短处理时间。"
      },
      "linkPath": "/contact"
    }
  ]
};

export default dailySeoContent;
